import { render, staticRenderFns } from "./TradePrint.vue?vue&type=template&id=5c8d0ba7&scoped=true&"
import script from "./TradePrint.vue?vue&type=script&lang=js&"
export * from "./TradePrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d0ba7",
  null
  
)

export default component.exports